/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: <  Ravi Ranjan Kumar, Mylavarapu Sarath Sai, Ujjwal Singh >

*/

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import { Grid, TextField, Typography, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import axios from "axios";
import { syncBaseUrl } from "database/onlineDb/baseUrl";
import { getAuthTokenFromSessionStorage } from "helpers/common";

//core components
// import TabsLists from './add-patient-tabs-setting'
const useStyles = makeStyles((theme) => ({
  textField: {
    margin: "10px",
  },
  textFieldAnother: {
    background: "#fff",
  },
  titleText: {
    background: theme.palette.action.active,
    color: "#fff",
    fontSize: "18px",
    textAlign: "center",
  },
  textContent: {
    background: "#fff",
    color: "#263238",
    fontSize: "18px",
    textAlign: "left",
    minHeight: "200px",
  },
  titleFont: {
    color: "#fff",
    fontSize: "18px",
  },
}));
// Sample data to display in the dialog
const versionInfoSample = {
  version_number: "1.0.5",
  release_date: "October 21, 2024",
  version_type: "Major Release",
  description: "This version includes performance improvements and bug fixes.",
};
export default function HelpMenuDialogBox(props) {
  const { onClose, value: valueProp, open, ...other } = props;
  const radioGroupRef = React.useRef(null);
  const [versionInfo, setVersionInfo] = React.useState(JSON.parse(sessionStorage.getItem("helpMenu-list"))||props.helpMenuData||versionInfoSample);
  const classes = useStyles();

  //  /getHelpMenuData
  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };
  // useEffect(async () => {
  //   try {
  //     const response = await axios.get(`${syncBaseUrl}/getHelpMenuData`, {
  //       headers: {
  //         authorization: getAuthTokenFromSessionStorage(),
  //       },
  //     });

  //     // Handle success
  //     console.log("HelpMenu1 Data:", response.data.helpMenuData[0]);
  //     setVersionInfo(response.data.helpMenuData[0]);
  //     console.log("Data of HelpMenu", versionInfo);
  //   } catch (error) {
  //     console.error("Error fetching helpmenu data:", error);
  //   }
  // }, []);
  const handleCancel = () => {
    props.handleCloseModel();
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      onEntering={handleEntering}
      aria-labelledby="confirmation-dialog-title"
      open={props.isOpenModel}
      onClose={handleCancel}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title" className={classes.titleText}>
        <Typography variant="h4" className={classes.titleFont}>
          {props.title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers className={classes.textContent}>
        <Typography variant="body1">
          <strong>Version Number :</strong> {versionInfo.version_number}
        </Typography>
        <Typography variant="body1">
          <strong>Release Date :</strong>{" "}
          {versionInfo.release_date.split("T")[0]}
        </Typography>
        <Typography variant="body1">
          <strong>Version Type :</strong> {versionInfo.version_type}
        </Typography>
        <Typography variant="body1">
          <strong>Description :</strong> {versionInfo.description}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleCancel}
          variant="outlined"
          color="secondary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

HelpMenuDialogBox.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
};
